import { pdfjs } from 'react-pdf';
import { requestInFlight, requestSuccess, requestError } from '../actions';
import { Dispatch } from 'redux';
import { getBooks, getBookContent, getBookPages } from 'api';
import { batch } from 'react-redux';
// PDFJS.PDFJS.workerSrc = `${String(process.env.PUBLIC_URL)}/pdf.worker.min.js`;
// PDFJS.PDFJS.disableStream = true;
// PDFJS.PDFJS.disableAutoFetch = true;
// PDFJS.PDFJS.disableRange = true;

export function getUsersWorkbooks() {
  return async (dispatch: Dispatch) => {
    dispatch(requestInFlight());

    try {
      const response = await getBooks();
      const workbooks = response.data.map((book, index) => {
        return { ...book, sortIndex: index };
      });

      dispatch(requestSuccess({ workbooks }));

      return workbooks;
    } catch (err) {
      dispatch(requestError(err));
    }
  };
}
/** custom use case in Workbook batching requests */
export function batchWorkbookContentAndPDF(bookUrl, bookId) {
  return async (dispatch: Dispatch) => {
    dispatch(requestInFlight());
    try {
      const pdf = await pdfjs.getDocument(bookUrl).promise;
      const { data: workbookContent } = await getBookContent(bookId);

      batch(() => {
        dispatch(requestSuccess({ pdf }));
        dispatch(requestSuccess({ workbookContent }));
      });
    } catch (err) {
      dispatch(requestError(err));
    }
  };
}

export function fetchWorkbookPDF(bookUrl: string) {
  return async (dispatch: Dispatch) => {
    if (!bookUrl) return;
    dispatch(requestInFlight());

    try {
      const pdf = await pdfjs.getDocument(bookUrl).promise;

      dispatch(requestSuccess({ pdf }));
    } catch (err) {
      dispatch(requestError(err));
    }
  };
}

export function getWorkbookTableOfContents(bookId: number) {
  return async (dispatch: Dispatch, _) => {
    dispatch(requestInFlight());

    try {
      const { data: workbookContent } = await getBookContent(bookId);

      dispatch(requestSuccess({ workbookContent }));
    } catch (err) {
      dispatch(requestError(err));
    }
  };
}
// TODO consider moving to custom
export function getPageDetails(bookId: number, page: string, isZoom = false) {
  return async (dispatch: Dispatch, _) => {
    dispatch(requestInFlight());
    const pageNumber = parseInt(page, 10);

    if (Number.isNaN(pageNumber)) {
      dispatch(requestSuccess({ pageDetails: [] }));
      return;
    }
    if (pageNumber === 0) return dispatch(requestSuccess({ pageDetails: [] }));

    const params: any = {
      include: ['resourceProducts'],
      ...(isZoom ? { pageNumber } : { pageNumber: [pageNumber, pageNumber + 1] })
    };

    try {
      const { data: pageDetails } = await getBookPages(bookId, params);

      dispatch(requestSuccess({ pageDetails }));
      return pageDetails;
    } catch (err) {
      dispatch(requestError(err));
    }
  };
}
// TODO consider moving to custom
export function setLastAccessed(book: any) {
  return async (dispatch: Dispatch, _) => {
    dispatch(requestInFlight());
    switch (book.type) {
      case 'activityBook':
        dispatch(requestSuccess({ lastWorkbook: book }));
        break;
      case 'teachersGuide':
        dispatch(requestSuccess({ lastTeachersGuide: book }));
        break;
      default:
        batch(() => {
          dispatch(requestSuccess({}));
          dispatch({ type: 'SET_LAST_ACCESSED_DEFAULT_CASE' });
        });
    }
  };
}
